export * from './getDocumentTargetAndLocationForPath';
